import { render } from "./TablePythagore.vue?vue&type=template&id=866f35c4"
import script from "./TablePythagore.vue?vue&type=script&lang=js"
export * from "./TablePythagore.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/FITS/Projets-VueJs/montessori-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__